import React, { Component } from 'react'
import Octicon, { Gear } from '@primer/octicons-react'
import Timezones from '~/components/OrdersPage/Timezones'
import Icon from '~/utils/Icon'
import UserSettings from '~/utils/UserSettings'
import styles from '~/styles/ordersPage.options.module.css'
import types from '~/types/ordersPage.ts'

export default class Options extends Component {
	static getInitialProps() {
		return {
			namespacesRequired: [ 'common' ],
		}
	}
	
	public constructor(props) {
		super(props)
		this.timezoneName = 'timezones'
		this.closeButtonRef = React.createRef()
		this.state = {
			saveButton: null,
			timezoneCode: this.props.timezoneCode,
			timezoneName: this.props.timezoneName,
		}
	}

	public render() {
		const isOpened = (this.props.clickLabel + '').startsWith('options')
		let clickLabel = 'options'
		let buttonClass = styles.button
		let dropdownClass = styles.hidden
		if (isOpened) {
			buttonClass += ' ' + styles.isOpened
			dropdownClass = styles.styledDropdown
			clickLabel = 'antiOptions'
		}
		return (
			<div 
				className={styles.main}
				clicklabel={clickLabel}
			>
				<div
					className={buttonClass}
				>
					<Octicon
			            icon={Gear}
			        />
			    </div>
			    <div
		            className={dropdownClass}
		            clicklabel="antiOptions"
		        >
		            <div
		            	clicklabel="options"
		            >
		              	<div className={styles.dropdownFrame}>
		              		<Timezones
		              		  name={this.timezoneName}
			                  toShow='picker'
			                  timezoneCode={this.state.timezoneCode}
			                  setTimezoneCode={this._setTimezoneCode.bind(this)}
			                  timezoneName={this.state.timezoneName}
			                  setTimezoneName={this._setTimezoneName.bind(this)}
			                  clickLabel={this.props.clickLabel || 'options'}
			                  onTimezoneUpdate={this._onTimezoneUpdate.bind(this)}
			                  onAction={this.props.onAction}
			                  onTimezonesUpdate={this._onTimezonesUpdate.bind(this)}
			                  t={this.props.t}
			                />
		              	</div>
		              	<div
		                  className={styles.closeButton}
		                  clicklabel="antiOptions"
		                  ref={this.closeButtonRef}
		                >
		                  <Icon
		                    iconName="close"
		                  />
		                </div>
		                <div
		                	className={styles.saveButton}
		                >
		                	<UserSettings
						        id={'mainSettings'}
						        saveButton={this.state.saveButton}
						        onSave={this._onSave.bind(this)}
						        t={this.props.t}
		                	/>
		                </div>
		            </div>
		        </div>
			</div>
		)
	}

	public componentDidUpdate(prevProps) {
		const previosIsOpened = (prevProps.clickLabel + '').startsWith('options')
		const currentIsOpened = (this.props.clickLabel + '').startsWith('options')
		if (previosIsOpened !== currentIsOpened) {
			this.setState({ timezoneCode: this.props.timezoneCode })
			this.setState({ timezoneName: this.props.timezoneName })
			if (this._timezonesToUpdate) {
				this._timezonesToUpdate()
			}
		}

	}

	_onTimezonesUpdate(callback) {
		this._timezonesToUpdate = callback
	}

	private _onTimezoneUpdate(data) {
		const value = data || {}
		this.setState({ saveButton: { id: 'mainSettings', value: { [this.timezoneName]: value } } })
	}

	private _setTimezoneCode(timezoneCode) {
		this.setState({ timezoneCode })
	}

	private _setTimezoneName(timezoneName) {
		this.setState({ timezoneName })
	}

	private _onSave = () => {
		this.setState({ saveButton: null })
	    this.props.setTimezoneCode(this.state.timezoneCode)
	    this.props.setTimezoneName(this.state.timezoneName)
	    this._timezonesToUpdate(true)
	    this.closeButtonRef.current?.click()
	}
}